import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState: TransactionsReduxState = {
    showTransactionModal: false,
    showEmailPromptModal: false,
    targetCheckoutDetails: {},
};

const transactionsSlice = createSlice({
    name: "transactions",
    initialState,
    reducers: {
        toogleTransactionDetailsModalOfPayment: (state, action: PayloadAction<{ showModal: boolean }>) => {
            const { showModal } = action.payload || {};

            if (showModal === undefined) return;

            state.showTransactionModal = showModal;
        },
        toogleGetEmailPromptModal: (state, action: PayloadAction<{ showModal?: boolean } | undefined>) => {
            const { showModal } = action.payload || {};

            if (showModal === undefined) return;

            state.showEmailPromptModal = showModal;
        },
        setTargetCheckoutDetails: (state, action: PayloadAction<{ checkoutDetails?: Partial<CashBoxCheckout> }>) => {
            const { checkoutDetails } = action.payload;
            state.targetCheckoutDetails = checkoutDetails || {};
        },
    },
});

export const {
    toogleTransactionDetailsModalOfPayment,
    toogleGetEmailPromptModal,
    setTargetCheckoutDetails,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
